import Ship from '../element/ship/ship';
import MoveToOrder from './moveToOrder';

export interface AttackMoveToOrderParams {
  x?: number;
  y?: number;
  target?: Ship;
}

export default class AttackMoveToOrder extends MoveToOrder {
  target?: Ship;

  constructor(params: AttackMoveToOrderParams) {
    super(params);
    this.color = 'red';
    this.target = params.target;
  }

  update(modifier: number): AttackMoveToOrder
  {
    if (this.target && this.getElements()[this.target.id] !== undefined) // target is still out there
    {
      this.x = this.target.x;
      this.y = this.target.y;
    }
    super.update(modifier);
    const element = this.getElement();
    element.attackNearestEnemy();
    return this;
  }
}
